<template>
  <div class="sections-container">
  <div class="header-sections">
    <span class="title-section">Puntos de venta</span>

    <div class="filter-colum-sections">
      <v-text-field
        style="width: 320px;"
        type="text"
        placeholder="Buscar"
        v-model="currentSearch"
        color="#222222"
        clearable
        @click:clear="clearSearch"
        variant="underlined">
        <template v-slot:append-inner>
          <v-icon color="#222222" icon="mdi-magnify" size="small"/>
        </template>
      </v-text-field>
    </div>
  </div>
  <div class="container-content-section">
    <pos-card v-for="item in pos" :key="item._id"
      :terminal="item" @refreshList="getPos"/>
  </div>

  <div class="fab-button"  @click="addPos">
    <v-icon icon="mdi-plus"/>
  </div>

  <add-edit-terminals ref="addEditModal" @refreshList="getPos"/>
</div>
</template>

<script>
import PosCard from '../cards/PosCard.vue'
import terminalsApi from '@/api/terminalsApi'
import AddEditTerminals from '../forms/AddEditTerminals.vue'
export default {
  name: 'CommerciaVuePos',
  components: {
    PosCard,
    AddEditTerminals
  },
  data () {
    return {
      currentSearch: '',
      pos: [],
      posFilter: []
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user?.role === 'finance' || this.user?.role === 'manager') {
      this.$router.push({ name: 'dashboard' })
    }
    this.getPos()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.getPos()
    }
  },

  methods: {
    clearSearch () {
      this.currentSearch = ''
      this.getPos()
    },
    addPos () {
      this.$refs.addEditModal.add()
    },
    async getPos () {
      this.pos = await terminalsApi.list(this.busines._id, this.currentSearch)
    }
  }
}
</script>

<style scoped>
@import '@/assets/styles/sections.css';
@import '@/assets/styles/inputs.css';
</style>
